import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const StockholderFormHistory = lazy(
  () => import('@components/Group/Portfolio/StockholderFormHistory')
);

/** 포트폴리오 상세 > 주주 현황 > 히스토리 관리 > 불러오기 */
const StockholderEdit = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense>
          <StockholderFormHistory />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default StockholderEdit;
